import React, { useCallback } from 'react';
import { Radio } from 'antd';
import { FormikValues, useField, useFormikContext } from 'formik';
import { RadioChangeEvent, RadioGroupProps } from 'antd/lib/radio';
import { useFormikFormContext } from '../FormikFormContext';
import { IExtraInputProps, useInputProps } from '../hooks/useInputProps';

export interface RadioInputProps<T extends FormikValues>
  extends Omit<RadioGroupProps, 'name'>,
    IExtraInputProps {
  name: keyof T & string;
}

/**
 * Campo per input di tipo Radio.
 */
export function RadioInput<T extends FormikValues>(props: RadioInputProps<T>) {
  const { name, extraOptions, ...otherProps } = props;
  const [field, meta, helpers] = useField<string>(name);
  const inputProps = useInputProps(props);
  const handleChange = useCallback(
    (e: RadioChangeEvent) => helpers.setValue(e.target.value),
    []
  );

  return (
    <Radio.Group
      {...otherProps}
      {...field}
      value={field.value}
      onChange={handleChange}
      {...inputProps}
    />
  );
}
